import React from 'react';
import remarkGfm from 'remark-gfm';
import ReactMarkdown, { Options } from 'react-markdown';

import traroMarkdown from './plugins/traroMarkdown';

export interface MarkdownProps extends Options {}

const remarkPlugins: Options['remarkPlugins'] = [[traroMarkdown], [remarkGfm, { singleTilde: false }]];

const Markdown = ({ children, ...props }: MarkdownProps) => (
  <ReactMarkdown {...props} transformLinkUri={null} remarkPlugins={remarkPlugins}>
    {children}
  </ReactMarkdown>
);

export default Markdown;
